import { AtsHttpClient } from '../../ats-http-client';
import { settings } from '../../settings';
import { Title } from '../../titles/types/title';
import { Bookmark } from './types';

const client = new AtsHttpClient();

export async function fetchBookmarks() {
  return client.get<Bookmark[]>('/me/bookmarks/references/all', settings.me());
}

export async function fetchContinueWatchingTitles() {
  return client.get<Title[]>('/me/bookmarks/continuewatching/titles', settings.me());
}
